export enum AuthenticationEffectsEnum {
	logIn = 'logIn$'
}
